/// <reference path='../_all.ts' />

module blog {
  'use strict';

  export class BlogCtrl {

    public static $inject = [
      '$scope',
      'pageMetaService',
      'blogService',
      '$timeout',
    ];

    constructor(
      private $scope: IBlogCtrlScope,
      private pageMetaService: navigation.IPageMetaService,
      private blogService: IBlogService,
      private $timeout: ng.ITimeoutService
    ) {
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      $scope.loadedBlogEntries = [];
      $scope.tags = [];
      $scope.entriesToLoad = 10;
      $scope.hideFooterButton = false;

      this.getMoreTopics();

      $scope.$watchCollection("tags", (newVal, oldVal) => {
        if (newVal == oldVal) return;
        this.getTopicRange();
      });

    }

    getMoreTopics() {
      this.blogService.loadTopicRange(this.$scope.loadedBlogEntries.length, this.$scope.entriesToLoad, "Blog", this.$scope.tags, false, true).then((response) => {
        response.data.forEach((element) => {
          this.$scope.loadedBlogEntries.push(element);
        })
        // wenn keine mehr => button ausblenden
        if (response.data.length < this.$scope.entriesToLoad) {
          this.$scope.hideFooterButton = true;
        }
      })
    }

    getTopicRange() {
      this.blogService.loadTopicRange(0, this.$scope.entriesToLoad, "Blog", this.$scope.tags, false, true).then((response) => {
        this.$scope.loadedBlogEntries = response.data;
      })
    }

    addTagFilter(tag: editor.ContentTag) {
      if (this.$scope.tags.filter(function (aTag) { return aTag.Id == tag.Id }).length > 0) return;
      this.$scope.tags.push(tag);
    }

    getFeaturedTopics() {
      this.blogService.loadTopicRange(0, 3, "Blog", [], true, true);
    }


  }
}